module.exports = __webpack_public_path__ + "img/copyright-detail.ff32fdd0.webp";